<template>
  <div class="cpm-wrapper">
    <!-- 配送完成 -->
    <div class="order-info-wrapper">
      <div class="order-info-left">
        <div class="top">
          <div class="order-title">订单信息</div>
          <el-alert
            v-if="orderDetail.refundOrderSnList && orderDetail.refundOrderSnList.length"
            :title="'当前订单有' + orderDetail.refundOrderSnList.length + '笔退货/退款单'"
            type="warning"
            show-icon
            close-text="退款详情"
            @close="viewRefundDetail(orderDetail.orderSn, orderDetail.refundOrderSnList)"
          ></el-alert>

          <p class="order-row">
            <span class="order-key">订单编号：</span>
            <span class="order-val">{{ orderDetail.orderSn }}</span>
          </p>
          <p class="order-row">
            <span class="order-key">下单人：</span>
            <span class="order-val">{{ orderDetail.submitSaleManName ? orderDetail.submitSaleManName : orderDetail.buyerName }}</span>
          </p>
          <p class="order-row">
            <span class="order-key">下单时间：</span>
            <span class="order-val">{{ orderDetail.submitOrderTime }}</span>
          </p>
          <p class="order-row">
            <span class="order-key">订单状态：</span>
            <span class="order-val">{{ getPayText(orderDetail.status) }}</span>
            <span v-if="orderDetail.status === 1" class="order-val orange">{{ getPayContent(orderDetail) }}</span>
          </p>
          <p class="order-row">
            <span class="order-key">买家留言：</span>
            <span class="order-val">
              {{ orderDetail.remark || '-' }}
            </span>
          </p>
          <p class="order-row">
            <span class="order-key">随货资质需求：</span>
            <span @click="showCei" class="order-val-blue">企业、商品资质随货需求</span>
          </p>
          <p v-if="orderDetail.orderInvoices && orderDetail.orderInvoices.length" class="order-row">
            <span class="order-key">发票信息：</span>
            <!-- <span class="order-val">{{ getInvoiceType(orderDetail.invoiceType) }}</span> -->
            <span class="order-val-blue" @click="onSeeInvoice">&emsp;查看发票</span>
          </p>

          <p class="order-row">
            <span class="order-key">合同信息：</span>
            <!-- <span class="order-val">{{ getInvoiceType(orderDetail.invoiceType) }}</span> -->
            <span class="order-val-blue" @click="openContract">查看合同</span>
          </p>
          <p v-if="orderDetail.userAddress" class="order-row">
            <span class="order-key">收货地址：</span>
            <span class="order-val">
              {{ orderDetail.userAddress.name }},{{ orderDetail.userAddress.mobile }},{{
                orderDetail.userAddress.province
              }}
              {{ orderDetail.userAddress.city }} {{ orderDetail.userAddress.region }}
              {{ orderDetail.userAddress.address }}
            </span>
          </p>
        </div>
        <div class="bottom">
          <p class="order-row btn-goup">
            <span
              class="primary-button"
              v-if="orderDetail.status === 1 && orderDetail.auditStatus !== 1"
              @click.stop="onCardPay(orderDetail)"
            >
              {{ orderDetail.payId === 0 ? '去支付' : '对公转账' }}
            </span>
            <span
              v-if="(orderDetail.status === 1 && orderDetail.auditStatus !== 1) && (orderDetail.payId === 0 || orderDetail.payId === 103)"
              class="plain-button"
              @click.stop="payOnBehalf"
            >
              他人代付
            </span>
            <span
              class="plain-button"
              v-if="orderDetail.status === 1 && orderDetail.auditStatus !== 1"
              @click.stop="onCancelOrder(orderDetail.orderSn)"
            >
              取消订单
            </span>
            <span class="primary-button" v-if="orderDetail.status === 3" @click.stop="confirmOrder">确认收货</span>
            <!--            <span class="primary-button" v-if="orderDetail.isRefunding" @click.stop="confirmRefund(orderDetail)">-->
            <!--              确认收到退款-->
            <!--            </span>-->
            <span
              class="primary-button"
              v-if="orderDetail.status === 4 || orderDetail.status === 5 || orderDetail.status === 7"
              @click.stop="bathAdd(orderDetail)"
            >
              再次购买
            </span>
            <span
              class="plain-button"
              v-if="orderDetail.status != 1 && orderDetail.payId === 2 && orderDetail.orderAmount !== 0"
              @click.stop="openPublic()"
            >
              查看对公转账凭证
            </span>
          </p>
        </div>
      </div>
      <div class="order-info-right">
        <!-- status === 1 待支付 -->
        <div class="top" v-if="orderDetail.status === 1">
          <div v-if="orderDetail.payId === 0">
            <div class="order-title">待支付</div>
            <div class="gray-title">暂无支付信息</div>
          </div>
          <div v-else>
            <div v-if="orderDetail.auditStatus === 0" class="order-title">待支付</div>
            <div v-if="orderDetail.auditStatus === 0" class="gray-title">暂无支付信息</div>
            <div v-else>
              <div :class="[orderDetail.auditStatus === 3 ? 'red' : '']">
                {{ orderDetail.auditStatusText || '待审核' }}
              </div>
              <div class="audit-info">{{ auditStatusText[orderDetail.auditStatus] }}</div>
              <ul class="list">
                <li class="item" v-for="(item, index) in auditList" :key="index">
                  <p class="store-name">{{ item.operatorName }} {{ item.operateTime }}</p>
                  <p class="store-reply">
                    <span v-if="item.status === '审核凭证失败'" class="status">
                      审核不通过。商家备注:{{ item.auditRemark || '无' }}
                    </span>
                    <span v-else class="status">{{ item.status }}</span>
                    <span
                      v-if="
                        item.urls[0] && !(item.status.includes('审核凭证成功') || item.status.includes('审核凭证失败'))
                      "
                      @click="showPic(item.urls[0])"
                      class="showPic pointer"
                    >
                      查看凭证
                    </span>
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div v-if="orderDetail.status === 1 && orderDetail.payId === 2" class="bot">
          <div
            @click="modifyVoucher"
            v-if="orderDetail.auditStatus === 1 || orderDetail.auditStatus === 3"
            class="primary-button"
          >
            修改凭证
          </div>
        </div>
        <!-- status === 6 待开户 -->
        <div class="top" v-if="orderDetail.status === 6">
          <div
            :class="[
              'order-title ',
              openAccountInfo.status === 2 ||
              openAccountInfo.certificateStatus === 1 ||
              openAccountInfo.certificateStatus === 2
                ? 'red'
                : ''
            ]"
          >
            {{ openAccountInfo.statusText }}
          </div>
          <div class="audit-info">{{ remarkText[openAccountInfo.status] || '' }}</div>
          <ul
            v-if="openAccountInfo.customerRelationRecords && openAccountInfo.customerRelationRecords.length"
            class="list"
          >
            <li class="item" v-for="(item, index) in openAccountInfo.customerRelationRecords" :key="index">
              <p class="store-name">{{ item.operateName }} {{ item.operateTime }}</p>
              <p class="store-reply">
                <span class="status">{{ item.auditRemark }}</span>
              </p>
            </li>
          </ul>
        </div>
        <div v-if="orderDetail.status === 6" class="bot">
          <div v-if="openAccountInfo.showUpdate" @click="modifyCeri" class="primary-button">更新证件</div>
        </div>
        <!-- status === 8 待开单 -->
        <div class="top" v-if="orderDetail.status === 8">
          <div class="order-title">待开单</div>
          <div class="audit-info">商家正在处理订单，请耐心等待</div>
        </div>
        <!-- status === 2 待配送 -->
        <div class="top" v-if="orderDetail.status === 2">
          <div class="order-title">物流信息</div>
          <div class="audit-info">暂无物流信息</div>
        </div>
        <!-- status ==== 3 配送中  4 已完成 -->
        <div v-if="orderDetail.status === 3 || orderDetail.status === 4" class="order-title">物流信息</div>
        <div v-if="orderDetail.status === 3 || orderDetail.status === 4" class="logistic-body">
          <div class="order-row">
            <span v-if="orderLogisticInfo.logisticsResp.shippingMethod === 1" class="order-key">发货方式：</span>
            <div v-if="orderLogisticInfo.logisticsResp.shippingMethod === 1" class="kuaidi">
              <span :class="['order-val']">商家自配</span>
            </div>
            <span v-if="orderLogisticInfo.logisticsResp.shippingMethod === 2 && logisticList.length" class="order-key">
              发货方式：
            </span>
            <div v-if="orderLogisticInfo.logisticsResp.shippingMethod === 2 && logisticList.length" class="kuaidi">
              <span
                :class="['order-val', logType === index ? 'order-val-active' : '']"
                v-for="(item, index) in logisticList"
                :key="index"
                @click="onChange(index)"
              >
                快递{{ index + 1 }}
              </span>
            </div>
          </div>
          <p v-if="orderLogisticInfo.logisticsResp.shopName" class="order-row">
            <span class="order-key">配送商：</span>
            <span class="order-val">{{ orderLogisticInfo.logisticsResp.shopName }}</span>
          </p>
          <p v-if="orderLogisticInfo.logisticsResp.shippingMethod === 2" class="order-row">
            <span class="order-key">物流公司：</span>
            <span class="order-val">{{ orderLogisticInfo.logisticsResp.expressComName }}</span>
          </p>
          <p v-if="orderLogisticInfo.logisticsResp.shippingMethod === 2" class="order-row">
            <span class="order-key">物流单号：</span>
            <span class="order-val">{{ orderLogisticInfo.logisticsResp.expressNo }}</span>
          </p>
          <div
            v-if="orderLogisticInfo.logisticsTraceRespList && orderLogisticInfo.logisticsTraceRespList.length"
            class="order-row"
          >
            <span class="order-key">物流跟踪：</span>
            <div class="logistics-list">
              <span :key="index" v-for="(item, index) in orderLogisticInfo.logisticsTraceRespList" class="order-val">
                {{ item.time }} {{ item.content }}
              </span>
            </div>
          </div>
        </div>
        <!-- status === 5 已关闭 nothing -->
        <!-- status === 7 已退款 nothing -->
        <!-- status === 9 退款中 -->
        <div v-if="orderDetail.status === 9" class="order-title">退款中</div>
        <p v-if="orderDetail.status === 9" class="order-row">
          <span class="order-key">退款方式：</span>
          <span class="order-val">{{ orderDetail.payId === 0 ? '在线支付' : '对公转账' }}</span>
        </p>
        <p v-if="orderDetail.status === 9" class="order-row">
          <span class="order-key">退款信息：</span>
          <span class="order-val">
            {{ orderDetail.payId === 0 ? '款项将原路退回' : '款项将在2-5个工作日内原路返回' }}
          </span>
        </p>
      </div>
    </div>
    <!-- 上传对公转账弹框 -->
    <PublicDialog @ok="refresh" :orderDetail="orderDetail" :orderSn="orderDetail.orderSn" ref="publicDialogRef" />
    <!-- 查看对公转账弹框 -->
    <PublicDetailDialog :orderSn="orderDetail.orderSn" ref="publicDetailDialogRef" />
    <!-- 随货资质弹窗 -->
    <CertificationDetail :info="orderDetail" ref="certificationDialogRef" />
  </div>
</template>

<script>
import PublicDialog from './PublicDialog.vue';
import PublicDetailDialog from './PublicDetailDialog.vue';
import CertificationDetail from './CertificationDetail.vue';
import { priceFenToYuan, parseCountDown } from '@/helpers/utils';
import * as api from '@/services';
import dayjs from 'dayjs';
const { ORDER_STATUS, orderQueryStatus } = require('../../constants/order');
export default {
  props: {
    orderDetail: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    status() {
      return this.orderDetail.status;
    }
  },
  watch: {
    orderDetail() {
      if (this.orderDetail.status === 1) {
        // 待支付
        if (this.orderDetail.auditStatus === 0 || this.orderDetail.auditStatus === 4) {
        } else {
          this.getPayList();
        }
      }
      if (this.orderDetail.status === 6) {
        // 待开户 查询开户信息
        this.getOpenAccountInfo();
      }
      if (this.orderDetail.status === 8 || this.orderDetail.status === 2) {
        // 待开单 do nothing
        // 待配送 do nothing
      }
      if (this.orderDetail.status === 3 || this.orderDetail.status === 4) {
        // 配送中 已完成 展示物流信息
        this.getLogisticList();
      }
    }
  },
  components: {
    PublicDialog,
    PublicDetailDialog,
    CertificationDetail
  },
  data() {
    return {
      auditText: {
        0: '待上传',
        1: '待审核',
        2: '审核通过',
        3: '审核不通过'
      },
      auditStatusText: {
        0: '请上传打款凭证',
        1: '商家将在1个工作日内审核完成，请耐心等待',
        2: '商家已核实您的打款',
        3: '请尽快修改您的打款凭证'
      },
      auditList: [], // 支付凭证审核记录
      openAccountInfo: {}, // 开户信息审核记录
      remarkText: {
        0: '请耐心等待商家处理',
        1: '您已开户完成，请耐心等待商家发货',
        2: '您的订单会退款，请及时关注'
      },
      logisticList: [], // 物流信息数组
      orderLogisticInfo: { logisticsResp: {} }, // 单个物流信息
      logType: 0 // 物流tab
    };
  },
  methods: {
    // 他人代付
    payOnBehalf() {
      this.$router.push(`/pay_payOnBehalf/${this.orderDetail.orderSn}`);
    },
    openContract() {
      this.$emit('openContract', this.orderDetail.orderSn);
    },
    onChange(index) {
      this.logType = index;
      this.orderLogisticInfo = this.logisticList[index];
    },
    async getLogisticList() {
      const res = await api.order.queryLogisticList({ orderSn: this.orderDetail.orderSn });
      this.logisticList = res;
      this.orderLogisticInfo = res[this.logType];
    },
    async getPayList() {
      const res = await api.order.listCertificateInfo({ orderSn: this.orderDetail.orderSn });
      this.auditList = res;
    },
    async getOpenAccountInfo() {
      const res = await api.order.queryAuditRecord({
        merchantId: this.orderDetail.merchantId
      });
      this.openAccountInfo = res;
    },
    showCei() {
      this.$refs.certificationDialogRef.dialogVisible = true;
    },
    async onCardPay() {
      Telescope.trackEvent({
        trackId: 'zyb2bpc-event-ddy-ddxqydjdgzzanB2B'
      });
      if (this.orderDetail.payId === 0) {
        // 在线支付
        const payOrderRes = await api.order.payOrder({ orderSn: this.orderDetail.orderSn });
        this.$router.push(`/pay_onlinePayment/${this.orderDetail.orderSn}/${payOrderRes.tradeNo}`);
        return
      }
      const res = await api.order.payOrder({ orderSn: this.orderDetail.orderSn });
      if (res.forward === 1) {
        this.$alert('请前往app完成微信支付', '提示', {
          confirmButtonText: '确定',
          cancelButtonClass: 'custom_confirm_button',
          confirmButtonClass: 'custom_confirm_button',
          alignFooter: 'right'
        });
      } else {
        this.$refs.publicDialogRef.dialogVisible = true;
      }
    },
    modifyVoucher() {
      Telescope.trackEvent({
        trackId: 'zyb2bpc-event-ddy-ddxqydjxgpzanB2B'
      });
      this.$refs.publicDialogRef.dialogVisible = true;
    },
    modifyCeri() {
      this.$alert('如若需修改资质，请前往APP完成', '提示', {
        confirmButtonText: '确定',
        cancelButtonClass: 'custom_confirm_button',
        confirmButtonClass: 'custom_confirm_button',
        alignFooter: 'right'
      });
    },
    //
    refresh() {
      this.$emit('refresh');
    },
    // 查看对公转账凭证
    openPublic() {
      this.$refs.publicDetailDialogRef.dialogVisible = true;
    },
    // 取消支付
    onCancelOrder() {
      this.$emit('cancelorder', this.orderDetail.orderSn);
    },
    bathAdd(orderInfo) {
      this.$emit('bathAdd', orderInfo);
    },
    confirmRefund(orderInfo) {
      this.$emit('confirmRefund', orderInfo);
    },
    confirmOrder() {
      this.$emit('confirmOrder', this.orderDetail.orderSn);
    },
    // 查看发票
    onSeeInvoice() {
      this.$previewImgList({
        urls: this.orderDetail.orderInvoices
      });
    },
    showPic(url) {
      this.$previewImg({
        url: url
      });
    },
    getPayContent(detail) {
      // 待支付
      if (detail.auditStatus === 1) return '';
      const diffTime = dayjs(detail.payTimeout) - dayjs();
      if (diffTime <= 0) {
        return '超时未支付关闭';
      }
      return `剩余${parseCountDown(diffTime.valueOf())}自动取消订单`;
    },
    getPayText(status) {
      if (status === 1 && this.orderDetail.auditStatus === 1) return '审核中';
      const diffTime = dayjs(this.orderDetail.payTimeout) - dayjs();
      if (status === 1 && diffTime <= 0) {
        return '已关闭';
      }
      const option = orderQueryStatus.filter((option) => {
        return option.value === status;
      });
      return option[0]?.label;
    },
    price(val) {
      return priceFenToYuan(val);
    },
    getInvoiceType(type) {
      if (type === -1) {
        return '无要求';
      } else {
        return type === 1 ? '专用发票' : '普通发票';
      }
    },
    viewRefundDetail(orderSn, refundOrderSnList) {
      const len = refundOrderSnList.length;
      if (len === 1) {
        const orderRefundSn = refundOrderSnList[0];
        this.$router.push(`/refundDetail?refundOrderSn=${orderRefundSn}`);
        return;
      }
      this.$router.push(`/refundList?orderSn=${orderSn}`);
    }
  }
};
</script>

<style lang="scss" scoped>
.cpm-wrapper {
  ::v-deep .el-alert {
    width: 400px;
  }
  ::v-deep .el-alert__closebtn {
    color: #1e8dff;
  }
  .order-info-wrapper {
    display: flex;
    height: 292px;
    font-size: 12px;
    border: 1px solid #dfdfdf;
    border-top: 2px solid #1e8dff;
    background: #ffffff;
    .order-title {
      margin-bottom: 16px;
    }
    .order-row {
      display: flex;
      margin-top: 8px;
    }
    .btn-goup {
      padding-left: 60px;
    }
    .order-key {
      flex-shrink: 0;
      color: #999999;
    }
    .order-val {
      display: inline-block;
      color: #333333;
      &.orange {
        color: #ff3737;
        padding-left: 8px;
      }
    }
    .red {
      color: #ff3737;
    }
    .logistics-list {
      .order-val {
        display: block;
        color: #333333;
        margin-bottom: 10px;
        cursor: default;
      }
      .order-val-orange {
        display: block;
        color: #d96900;
        cursor: default;
        margin-bottom: 10px;
      }
    }
    .order-val-blue {
      color: #1e8dff;
      cursor: pointer;
    }
    .order-val-orange {
      color: #d96900;
      cursor: pointer;
    }
    .plain-button {
      display: inline-block;
      height: 28px;
      padding: 0 16px;
      color: #555555;
      line-height: 26px;
      text-align: center;
      border: 1px solid #dedede;
      cursor: pointer;
      margin-right: 8px;
    }
    .primary-button {
      display: inline-block;
      height: 28px;
      padding: 0 16px;
      color: #ffffff;
      line-height: 26px;
      text-align: center;
      background: #1e8dff;
      border: 1px solid #1e8dff;
      cursor: pointer;
      margin-right: 8px;
    }
    .order-info-left {
      width: 480px;
      padding: 16px 24px 0px;
      border-right: 1px solid #dfdfdf;
      display: flex;
      flex-direction: column;
      .top {
        flex: 1;
        overflow-y: auto;
        min-height: 150px;
      }
      .bottom {
        height: 56px;
        background: #ffffff;
        padding-top: 12px;
        padding-bottom: 16px;
        p {
          margin-top: 0;
        }
      }
    }
    .order-info-right {
      flex: 1;
      padding: 16px 24px 15px;
      overflow-y: auto;
    }
  }

  .order-info-right {
    display: flex;
    flex-direction: column;
    .top {
      flex: 1;
      overflow-y: auto;
      .order-title-red {
        color: #ff0000;
      }
      .sub-title {
        font-size: 12px;
        font-weight: 400;
        color: #8c8c8c;
      }
      .gray-title {
        height: 12px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 12px;
      }
      .red {
        color: #ff3737;
      }
      .audit-info {
        margin-top: 16px;
        margin-bottom: 12px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 12px;
      }
      .list {
        .item {
          width: 480px;
          // height: 56px;
          padding: 12px 16px;
          background: #f9f9f9;
          margin-bottom: 12px;
          .store-name {
            font-size: 12px;
            font-weight: 400;
            color: #999999;
          }
          .store-reply {
            font-size: 12px;
            font-weight: 400;
            color: #333333;
            line-height: 18px;
            margin-top: 2px;
          }
          .showPic {
            margin-left: 16px;
            height: 12px;
            font-size: 12px;
            font-weight: 400;
            color: #1e8dff;
            line-height: 12px;
          }
        }
      }
    }
    .bot {
      height: 56px;
      background: #ffffff;
      padding-top: 12px;
      padding-bottom: 16px;
    }
  }
}
.kuaidi {
  .order-val {
    padding-right: 12px;
    cursor: pointer;
    color: #8c8c8c;
  }
  .order-val-active {
    color: #1e8dff !important;
  }
}
</style>
